import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      width: 610,
    },
    dialogTitle: {
      paddingBottom: theme.spacing(3),

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: theme.spacing(1),

      color: theme.palette.primary.dark,

      '& .MuiTypography-root': {
        color: theme.palette.primary.dark,
        fontSize: '2.2rem',
        fontWeight: 500,
      },
    },
    dialogContent: {
      backgroundColor: '#F9F9FB',

      '& ul': {
        margin: 0,
        paddingInline: '2.4rem',
      },

      '& li': {
        marginBottom: theme.spacing(2),
        fontSize: '1.4rem',
      },

      '& label': {
        width: '96%',
        marginLeft: theme.spacing(1.6),
        marginRight: 0,
        border: '1px solid #F0F0F0',
        borderRadius: 4,

        '& .MuiCheckbox-root': {
          color: theme.palette.secondary.main,
        },
      },
    },
    dialogActions: {
      backgroundColor: '#F9F9FB',
      justifyContent: 'space-between',
      paddingRight: theme.spacing(2.2),
      paddingLeft: theme.spacing(2.8),

      '& button': {
        width: 'fit-content',
        height: 36,

        marginTop: 0,
      },
    },
  }),
)
